<div mat-dialog-title>
  <div fxLayout="column" fxLayoutAlign="center center">
    <div style="font-size: 16px;font-weight: 900;">SignalR</div>
    <div style="font-size: 12px;">Attempting to auto reconnect...</div>
  </div>
</div>
<div mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign="center center">
    <img style="margin-top: -14px;" width="200" src="assets/connection-lost.gif" />
  </div>
</div>
<div mat-dialog-actions align="center">
  <button (click)="reconnect()" mat-button color="accent">FORCE RECONNECT</button>
</div>
